export default function messageOnGetFeatureToggleInformations(status) {
    let message

    switch (status) {
        case 'invalid':
            message = 'Ops! Os campo(s) est(ão) incorrento(s) '
            break
        case 503:
            message =
                'Ops! Ocorreu um problema com a internet e não conseguimos pegar as informacoes do Feature Toggle.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não pegamos as informacoes do Feature Toggle. Por favor, tente novamente mais tarde.'
    }
    return message
}
